import { Icon } from '../components/Icon';
import { Seo } from '../components/Seo';
import { useMoonbase } from '../lib/moonbase';

export function AccountPage() {
  const moonbase = useMoonbase();
  const action = (configuredAction: () => void) => moonbase.configured ? configuredAction : moonbase.openSetup;

  return (
    <>
      <Seo title="Downloads and licenses" description="Sign in to download owned plugins, manage activations and recover your Wavecraft Audio account." path="/account" noIndex />
      <section className="account-hero section--grain">
        <div className="shell account-hero__inner">
          <span className="eyebrow eyebrow--line">Customer account</span>
          <h1>Downloads, licenses and activations in one place.</h1>
          <p>Sign in with the email connected to your purchase. You do not need to remember a separate serial number for routine recovery.</p>
          <div className="account-hero__greeting" hidden={moonbase.configured}>
            <span>Store preview</span><strong>Connect Moonbase to enable customer accounts.</strong>
          </div>
          {moonbase.configured && (
            <>
              <button className="button button--light" type="button" hidden data-moonbase-if="!user" onClick={moonbase.signIn}>Sign in to your account <Icon name="arrow" /></button>
              <button className="button button--light" type="button" hidden data-moonbase-if="user" onClick={moonbase.viewAccount}>Hello, <span data-moonbase-render="user.name">customer</span> <Icon name="arrow" /></button>
            </>
          )}
          {!moonbase.configured && <button className="button button--light" type="button" onClick={moonbase.openSetup}>Connect store <Icon name="arrow" /></button>}
        </div>
      </section>

      <section className="section account-tools">
        <div className="shell account-tools__grid">
          <button type="button" onClick={action(moonbase.viewProducts)}><Icon name="download" /><span><strong>My products</strong>Download the latest installers</span><Icon name="arrow" /></button>
          <button type="button" onClick={action(moonbase.viewAccount)}><Icon name="account" /><span><strong>Account details</strong>Password and email settings</span><Icon name="arrow" /></button>
          <button type="button" onClick={action(moonbase.viewAccount)}><Icon name="key" /><span><strong>Licenses & activations</strong>Manage your three authorized computers</span><Icon name="arrow" /></button>
          <button type="button" onClick={action(moonbase.activateProduct)}><Icon name="clock" /><span><strong>Offline activation</strong>Exchange a device token for a license</span><Icon name="arrow" /></button>
        </div>
      </section>

      <section className="section activation-explainer">
        <div className="shell activation-explainer__grid">
          <div>
            <span className="eyebrow">How recovery works</span>
            <h2>Your account proves ownership. The local license authorizes a computer.</h2>
          </div>
          <ol>
            <li><span>1</span><div><strong>Install</strong><p>Download the current plugin build from your product library.</p></div></li>
            <li><span>2</span><div><strong>Sign in</strong><p>Open activation and authenticate through the secure browser flow.</p></div></li>
            <li><span>3</span><div><strong>Authorize</strong><p>Moonbase issues a signed token for that computer and stores it locally.</p></div></li>
            <li><span>4</span><div><strong>Recover</strong><p>On a new machine, sign in again or release an old activation from your account.</p></div></li>
          </ol>
        </div>
      </section>

      <section className="section account-security">
        <div className="shell account-security__inner">
          <Icon name="shield" />
          <div><span className="eyebrow">A sensible outage policy</span><h2>Paid software should not disappear because a server is briefly unavailable.</h2><p>Configure validation intervals and grace periods in the plugin-side Moonbase SDK. Never make a network request from the real-time audio thread.</p></div>
        </div>
      </section>
    </>
  );
}
